<template>
  <v-app-bar
    fixed
    color="dark"
    elevation="1"
    app
    dark
  >
    <v-img
      src="../../assets/main-logo.png"
      max-width="100"
      class="mr-5"
    ></v-img>

  </v-app-bar>
</template>

<script>
export default {
};
</script>

<style>
</style>